import {hideGlobalLoader, showGlobalLoader} from '../../state/slice/global';
import {dispatch} from '../../state/store';

const showGlobalLoaderByType = (props) => {
    dispatch(showGlobalLoader(props));
};

const hideGlobalLoaderByType = (props) => {
    dispatch(hideGlobalLoader(props));
};

export default {showGlobalLoaderByType, hideGlobalLoaderByType};
